'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

var apiGetResumeScore = function (jobId, apiGetScore, accessToken, langCode) { return __awaiter(void 0, void 0, void 0, function () {
    var url, res, ex_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                url = "".concat(apiGetScore, "?jobId=").concat(jobId);
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode,
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    })];
            case 1:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                ex_1 = _a.sent();
                console.error('GET Resume Score', ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { apiGetResumeScore };
//# sourceMappingURL=service.js.map
